import type { IAdviceItem } from './IAdviceItem';

/**
 * Текст поради мовою інтерфейсу (рядки `modBody.advice.*` з множиною за кількістю записів); для «вузького місця» — підпис статусу етапу
 * (`stageLabel`). Чиста функція: переклад дає `t`.
 */
export function adviceText(item: IAdviceItem, t: (key: string, vars?: Record<string, unknown>) => string, stageLabel: (value: string) => string): string {
  if (item.key === 'bottleneck') return t('modBody.advice.bottleneck', { stage: stageLabel(item.stage ?? '') });
  if (item.key === 'none') return t('modBody.advice.none');
  return t(`modBody.advice.${item.key}`, { count: item.count ?? 0 });
}
